import axios from "@/api/axiosInstance";
import { UpdateCourseRequest, UpdateCourseResponse } from "./types";

export const updateCourse = async (
  uuid: string,
  requestData: UpdateCourseRequest,
): Promise<UpdateCourseResponse> => {
  const response = await axios.put<UpdateCourseResponse>(
    `/api/private/learning-center/courses/${uuid}`,
    requestData,
  );
  return response.data;
};
